import React from 'react';
import { Input, Button} from 'antd';

import './ElementContainer.css';

const ControlPanel = ({ smiles, onSmilesChange, onGetSmiles, onSetSmiles, onFragmentize }) => {
  const handleInputChange = (e) => {
    onSmilesChange(e.target.value);
  };
  
  return (
    <div className="element-container">
      
        
        <div className='title' style={{ textAlign: 'left' }}>
          <label htmlFor="inputSmiles">Input SMILES Here</label>
        </div>
      <div>
        <Input.TextArea
          id="inputSmiles"
          value={smiles}
          onChange={handleInputChange}
          placeholder="Enter SMILES"
          rows={4}
        />
      </div>
      <div className="button-group-control-panel">
        <Button onClick={onGetSmiles} type="primary">Get SMILES</Button>
        <Button onClick={onSetSmiles} type="primary">Set SMILES</Button>
        <Button onClick={onFragmentize} type="primary">Fragmentize Molecule</Button>
      </div>
    </div>
  );
};

export default ControlPanel;
